/** @format */
import React from 'react'

import Base from '../Base'
import BatchList from './BatchList'

export default class SupplierDocuments extends Base {
    path = 'fergus-logs/supplier-document'

    formatResults(rawResult) {
        const {
            value: { results },
        } = rawResult

        const groupedResults = {}

        results.forEach((result) => {
            const { batchId } = result
            if (!batchId) {
                return
            }

            groupedResults[batchId] = [
                ...(groupedResults[batchId] || []),
                result,
            ]
        })

        return Object.entries(groupedResults)
            .map(([batchId, entries]) => {
                const beforeFileList = entries
                    .filter((entry) => entry.beforeAfter === 'before')
                    .map((entry) => entry.fileList)
                    .flat()
                const afterFileList = entries
                    .filter((entry) => entry.beforeAfter === 'after')
                    .map((entry) => entry.fileList)
                    .flat()

                const processedFiles = beforeFileList.filter(
                    (filename) => !afterFileList.includes(filename)
                )

                return {
                    batchId,
                    supplierName: entries[0].supplierName,
                    date: new Date(entries[0].date),
                    processedFiles,
                    unprocessedFiles: afterFileList,
                }
            })
            .sort((a, b) => b.date - a.date)
    }

    render() {
        const queryId = this.getQueryId()
        const { loading, results, page, search, counter } = this.state

        const sliceSize = 10
        const sliceStart = page * sliceSize
        const sliceEnd = (page + 1) * sliceSize + 1
        const resultsSlice = results
            .filter((result) => {
                if (!search) {
                    return true
                }

                return JSON.stringify(result)
                    .toUpperCase()
                    .includes(search.toUpperCase())
            })
            .slice(sliceStart, sliceEnd)

        return (
            <div>
                <h1>Supplier Document Logs</h1>
                <div className="container-fluid">
                    <div className="col-md-12">
                        <div className="btn-toolbar">
                            <div className="btn-group">
                                <button
                                    className="btn btn-primary"
                                    onClick={() => this.getQueryResult(queryId)}
                                >
                                    Get Logs
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        this.startQuery()
                                    }}
                                >
                                    Refresh Logs
                                </button>
                            </div>
                            <div className="input-group">
                                <input
                                    className="form-control"
                                    placeholder="Filter"
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({
                                            search: e.target.value,
                                        })
                                    }}
                                />
                            </div>
                            <div className="btn-group">
                                <button
                                    className="btn btn-primary"
                                    onClick={() =>
                                        this.setState({
                                            page: Math.max(0, page - 1),
                                        })
                                    }
                                >
                                    Prev
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={() =>
                                        this.setState({
                                            page: page + 1,
                                        })
                                    }
                                >
                                    Next
                                </button>
                            </div>
                            <div className="btn-group">
                                <button
                                    className="btn btn-default"
                                    onClick={() => {
                                        console.info('this.state', this.state)
                                        console.info(
                                            "If you are the first non-dev to send a screenshot of this message to me (Nick 3) once this page is live, I'll give you 5 tacos. Might have to be weekend tacos."
                                        )
                                        console.info(
                                            "If you are first dev, I'll give you 2 tacos cause this message isn't hidden in the pull request."
                                        )
                                    }}
                                >
                                    Dev Button
                                </button>
                            </div>
                        </div>
                        <p style={{ marginTop: '1em' }}>
                            Refreshing logs takes about 2 minutes. Only refresh
                            if the existing logs are out-of-date.
                        </p>
                        <p>
                            If you want to filter by supplier, invoice number or
                            something, you can type the filter term or part of
                            it in the "Filter" box.
                        </p>
                        <p>
                            Use the Next and Prev buttons to see more results.
                        </p>
                        {!loading && (
                            <p>
                                Page: {page + 1}/
                                {Math.ceil(results.length / sliceSize)}
                            </p>
                        )}
                        {loading && (
                            <p>Loading ({(counter - 1) * 5} seconds)</p>
                        )}
                        {resultsSlice.length > 0 ? (
                            <div>
                                {resultsSlice.map(
                                    ({
                                        batchId,
                                        date,
                                        processedFiles,
                                        unprocessedFiles,
                                        supplierName,
                                    }) => (
                                        <BatchList
                                            key={batchId}
                                            batchId={batchId}
                                            date={date}
                                            processedFiles={processedFiles}
                                            unprocessedFiles={unprocessedFiles}
                                            supplierName={supplierName}
                                        />
                                    )
                                )}
                            </div>
                        ) : (
                            <div>
                                {page === 0
                                    ? 'There are no log entries to show'
                                    : 'There are no more log entries to show'}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/pages/FergusLogs/SupplierDocuments/index.js